<template>
  <div class="card">
    <div class="card header-inclusion">
      <img
        src="assets/layout/desarrollo-social/banner.png"
        alt="Gerencia de Desarrollo"
      />
    </div>
    <TabView>
      <TabPanel header="Indicadores">
        <div class="p-grid mt-4 p-justify-center" style="gap: 20px">
          <div
            v-for="modulo in embedList"
            :key="modulo.id"
            class="card p-col-12 p-md-6 p-lg-3 pointer"
            @click="goTo(modulo.url)"
          >
            <a class="text-center">
              <img
                :src="'assets/layout/desarrollo-social/' + modulo.image"
                :alt="modulo.nombre"
                style="width: 250px; height: 250px"
              />
            </a>
            <div class="content">
              <h4 class="p-text-bold text-color-grsm text-center">
                {{ modulo.entidad }}
              </h4>
              <p class="text-center" style="font-size: 18px">
                {{ modulo.nombre }}
              </p>
            </div>
          </div>
        </div>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useEmbedStore } from "@/store/embedStore";

export default {
  data() {
    return {
      isLoading: true,
      embedList: [],
      isObras: true,
      selectButtonValue1: { name: "OBRAS", code: "O2" },
      selectButtonValues1: [
        { name: "Gastos Corrientes", code: "O1" },
        { name: "OBRAS", code: "O2" },
      ],
      nacionalNormativas: [],
      regionalNormativas: [],
    };
  },
  components: {},
  productService: null,
  eventService: null,

  mounted() {
    this.loadEmbed();
  },
  methods: {
    style() {
      let randomColor = Math.floor(Math.random() * 16777215).toString(16);
      let color = "#" + randomColor;
      return color;
    },
    click(item) {
      let href = "#";
      if (item.items != undefined && item.items != "undefined") {
        let child = item.items[0];

        if (child.items.length == 0) {
          href = item.to;
        } else {
          if (child.items != undefined && child.items != "undefined") {
            let subMenu = child.items[0];
            href = subMenu.to;
          }
        }
      }
      return href;
    },
    async loadEmbed() {
      this.isLoading = true;
      const embedStore = useEmbedStore();
      try {
        const result = await embedStore.getEmbedBySubGroup(17);

        if (result.data.success) {
          this.embedList = result.data.data;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    goTo(link) {
      window.open(link, "_blank");
    },
  },
  computed: {
    ...mapGetters({ items: "gsdialogoauth/getMenu" }),
  },
};
</script>
<style lang="scss">
.header-inclusion {
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 0px;
}
.text-color-grsm {
  color: #822737;
}

.pointer {
  cursor: pointer;
}
.header-nivel {
  margin-left: 60px;
  border-left: 3px solid #822737;
}
</style>
